/**
 * One icon family, drawn on a 24-unit grid with a 1.6 stroke.
 * Every icon-only control must pass a label — see IconButton.
 */
import type { SVGProps } from "react";

const NAMES = {
  search: "M10.5 3a7.5 7.5 0 105.303 12.803l4.197 4.197 1.414-1.414-4.197-4.197A7.5 7.5 0 0010.5 3zm0 2a5.5 5.5 0 110 11 5.5 5.5 0 010-11z",
  calendar: "M7 3v2M17 3v2M3.5 8.5h17M5 5.5h14a1.5 1.5 0 011.5 1.5v12A1.5 1.5 0 0119 20.5H5A1.5 1.5 0 013.5 19V7A1.5 1.5 0 015 5.5z",
  clock: "M12 3a9 9 0 100 18 9 9 0 000-18zM12 7.5V12l3 2",
  users: "M16 19v-1.5a3.5 3.5 0 00-3.5-3.5h-5A3.5 3.5 0 004 17.5V19M10 11a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM20 19v-1.5a3.5 3.5 0 00-2.6-3.4M15 4.2a3.5 3.5 0 010 6.6",
  door: "M14.5 3.5H6a1.5 1.5 0 00-1.5 1.5v14A1.5 1.5 0 006 20.5h8.5M14.5 3.5L19 5v14l-4.5 1.5V3.5zM16 12h.01",
  grid: "M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z",
  tablet: "M6.5 2.5h11A1.5 1.5 0 0119 4v16a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 015 20V4a1.5 1.5 0 011.5-1.5zM10.5 18.5h3",
  check: "M4.5 12.5l5 5 10-11",
  x: "M6 6l12 12M18 6L6 18",
  chevronRight: "M9 5l7 7-7 7",
  chevronLeft: "M15 5l-7 7 7 7",
  chevronDown: "M6 9l6 6 6-6",
  plus: "M12 5v14M5 12h14",
  minus: "M5 12h14",
  settings: "M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.6 1.6 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.6 1.6 0 00-1.8-.3 1.6 1.6 0 00-1 1.5V21a2 2 0 11-4 0v-.1A1.6 1.6 0 008 19.4a1.6 1.6 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.6 1.6 0 00.3-1.8 1.6 1.6 0 00-1.5-1H2a2 2 0 110-4h.1A1.6 1.6 0 004.6 8a1.6 1.6 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.6 1.6 0 001.8.3H9a1.6 1.6 0 001-1.5V2a2 2 0 114 0v.1a1.6 1.6 0 001 1.5 1.6 1.6 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.6 1.6 0 00-.3 1.8V9a1.6 1.6 0 001.5 1H22a2 2 0 110 4h-.1a1.6 1.6 0 00-1.5 1z",
  shield: "M12 3l7 3v5.5c0 4.2-2.9 8.1-7 9.5-4.1-1.4-7-5.3-7-9.5V6l7-3z",
  chart: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  bell: "M18 8a6 6 0 10-12 0c0 6-2 7-2 7h16s-2-1-2-7M13.7 20a2 2 0 01-3.4 0",
  list: "M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01",
  refresh: "M20 11a8 8 0 10-.8 4.5M20 5v5h-5",
  link: "M10 13a5 5 0 007.5.5l3-3a5 5 0 00-7-7l-1.7 1.7M14 11a5 5 0 00-7.5-.5l-3 3a5 5 0 007 7L12.2 19",
  qr: "M4 4h6v6H4V4zM14 4h6v6h-6V4zM4 14h6v6H4v-6zM14 14h2v2h-2v-2zM18 14h2v2h-2v-2zM14 18h2v2h-2v-2zM18 18h2v2h-2v-2z",
  logout: "M9 20H5a1.5 1.5 0 01-1.5-1.5v-13A1.5 1.5 0 015 4h4M16 16l4-4-4-4M20 12H9",
  sun: "M12 17a5 5 0 100-10 5 5 0 000 10zM12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4",
  moon: "M20 14.5A8.5 8.5 0 019.5 4a8.5 8.5 0 1010.5 10.5z",
  warning: "M12 3.5L21 19H3l9-15.5zM12 10v4M12 17h.01",
  info: "M12 3a9 9 0 100 18 9 9 0 000-18zM12 11v5M12 8h.01",
  building: "M4 21V5.5A1.5 1.5 0 015.5 4h7A1.5 1.5 0 0114 5.5V21M14 10h4.5A1.5 1.5 0 0120 11.5V21M2 21h20M7.5 8h3M7.5 12h3M7.5 16h3M17 14h.5M17 17.5h.5",
  download: "M12 3v12M7 11l5 5 5-5M4 20h16",
  filter: "M3 5h18l-7 8v6l-4 2v-8L3 5z",
  history: "M3.5 12a8.5 8.5 0 108.5-8.5A8.4 8.4 0 006 6M3.5 4v3.5H7M12 7.5V12l3 1.8",
  play: "M7 4.5l12 7.5-12 7.5v-15z",
  stop: "M6.5 6.5h11v11h-11z",
  arrowRight: "M4 12h16M14 6l6 6-6 6",
  menu: "M3 6h18M3 12h18M3 18h18",
  wifiOff: "M2 2l20 20M8.6 16.6a5 5 0 016.8 0M5 13a10 10 0 013.5-2.3M19 13a10 10 0 00-4.3-2.5M2.5 9.5a15 15 0 014-2.6M21.5 9.5a15 15 0 00-8.8-3.4M12 20h.01",
  battery: "M3 8.5h13a1.5 1.5 0 011.5 1.5v4a1.5 1.5 0 01-1.5 1.5H3A1.5 1.5 0 011.5 14v-4A1.5 1.5 0 013 8.5zM20 10.5v3",
  bolt: "M13 2L4 14h7l-1 8 9-12h-7l1-8z",
  key: "M15 8a4 4 0 10-3.5 4L13 13.5V16h2.5v2.5H18l2-2V14l-2.5-2.5A4 4 0 0015 8z",
  mail: "M3.5 6.5h17v11h-17v-11zM4 7l8 6 8-6",
  eye: "M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z",
  phone: "M6.5 3.5h3l1.5 4-2 1.5a12 12 0 006 6l1.5-2 4 1.5v3a1.5 1.5 0 01-1.7 1.5A17 17 0 015 5.2 1.5 1.5 0 016.5 3.5z",
  video: "M3.5 6.5h11a1.5 1.5 0 011.5 1.5v8a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 012 16V8a1.5 1.5 0 011.5-1.5zM16 10.5l5-3v9l-5-3v-3z",
  accessible: "M12 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM9 8.5l3 1v3.5h3.5M8.5 12a4.5 4.5 0 105.8 6",
} as const;

export type IconName = keyof typeof NAMES;

interface Props extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName;
  size?: number;
}

export function Icon({ name, size = 20, ...rest }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {NAMES[name].split(" M").map((segment, index) => (
        <path key={index} d={index === 0 ? segment : `M${segment}`} />
      ))}
    </svg>
  );
}
